<table class="table table-bordered">
    <thead>
      <tr>
        <th scope="col">{{ 'annee_edition' | translate }}</th>
        <th scope="col">{{ 'nbr' | translate }}</th>
        <th scope="col">%</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let l of years">
        <td>{{ l.name }}</td>
        <td>{{ l.y }}</td>
        <td>{{ l.y*100/totale | number : '1.2-2'  }} %</td>
      </tr>
      <tr>
        <th scope="row">{{ 'total' | translate }}</th>
        <th scope="row">{{ totale }}</th>
        <th>{{ totale*100/totale | number  }} %</th>
      </tr>
    </tbody>
</table>
<div  *ngIf="years">
    <div class="chart-wrapper">
        <canvas baseChart 
        [data]="doughnutChartData"
        [labels]="doughnutChartLabels"
        [chartType]="doughnutChartType" 
        [legend]="false"
        (click)="chartClicked($event.label)"
        height="30" color="#007bff"
        [options]="options"
        width="60">
      </canvas>
    </div>
</div>